import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import { MESSAGES } from 'appconstants';

import {
  PLANSDETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchPlansDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.PLAN}/${gid}`);

const fetchSubscription = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const queryParam = `&planGid.EQ=${payload.gid}`;
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance.get(`${API_END_POINTS.SUBSCRIPTION}${query}${queryParam}${sorting}`);
};

export function* getPlansDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchPlansDetails, action.payload);
    yield put({ type: PLANSDETAILS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: PLANSDETAILS.FAILED, payload: e.response.data });
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* getPlansPayments(action) {
  try {
    const { data: { entity } } = yield call(fetchSubscription, action.payload);
    yield put({ type: PLANSDETAILS.PAYMENTS_SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: PLANSDETAILS.FAILED, payload: e.response.data });
  }
}
